/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A configurable eligibility/attestation checkbox shown in the challenge sign-in modal alongside the standard 18+ and Terms checkboxes. Used to capture per-challenge legal/eligibility acknowledgments (e.g. "I am a U.S. resident") without forking the modal per challenge.
 * @export
 * @interface ChallengeEligibilityCheckbox
 */
export interface ChallengeEligibilityCheckbox {
    /**
     * Stable identifier written into ChallengeMembership.eligibility on submit. Camel-case (e.g. isUSResident, over21).
     * @type {string}
     * @memberof ChallengeEligibilityCheckbox
     */
    key: string;
    /**
     * User-facing checkbox label.
     * @type {string}
     * @memberof ChallengeEligibilityCheckbox
     */
    label: string;
    /**
     * If true, the signup buttons stay disabled until this checkbox is checked.
     * @type {boolean}
     * @memberof ChallengeEligibilityCheckbox
     */
    required: boolean;
}

/**
 * Check if a given object implements the ChallengeEligibilityCheckbox interface.
 */
export function instanceOfChallengeEligibilityCheckbox(value: object): value is ChallengeEligibilityCheckbox {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function ChallengeEligibilityCheckboxFromJSON(json: any): ChallengeEligibilityCheckbox {
    return ChallengeEligibilityCheckboxFromJSONTyped(json, false);
}

export function ChallengeEligibilityCheckboxFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeEligibilityCheckbox {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'required': json['required'],
    };
}

export function ChallengeEligibilityCheckboxToJSON(json: any): ChallengeEligibilityCheckbox {
    return ChallengeEligibilityCheckboxToJSONTyped(json, false);
}

export function ChallengeEligibilityCheckboxToJSONTyped(value?: ChallengeEligibilityCheckbox | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'required': value['required'],
    };
}

